/**
 * Global operator audit log — the REAL DB-backed feed.
 *
 * Backed by GET /admin/audit-events (api/routes/admin.py:list_audit_events):
 * every operator action across the cockpit (flag toggles, account/strategy/
 * segment changes, deployment create, flatten, arming…) lands in
 * operator_audit_events, newest-first, with the operator's email + display
 * name resolved. Optional filters: target_kind, target_id.
 */
import type { ApiResult } from './client';
import { get } from './client';
import { auditEventListSchema, type AuditEvent } from './admin-brokers';

export type { AuditEvent } from './admin-brokers';

export interface ListAuditParams {
  target_kind?: string;
  target_id?: string;
  limit?: number;
}

export const listAuditEvents = (
  params: ListAuditParams = {},
  signal?: AbortSignal,
): Promise<ApiResult<AuditEvent[]>> => {
  const qs = new URLSearchParams();
  if (params.target_kind) {qs.set('target_kind', params.target_kind);}
  if (params.target_id) {qs.set('target_id', params.target_id);}
  qs.set('limit', String(params.limit ?? 300));
  return get(`/admin/audit-events?${qs.toString()}`, auditEventListSchema, { signal });
};
